import {
  AltchaWidget,
  type AltchaWidgetHandle,
} from "@/features/post/components/AltchaWidget";
import type { AltchaOperation } from "@/features/post/lib/altchaChallengeController";

type AltchaWidgetProps = {
  active?: boolean;
  hideFooter?: boolean;
  operation: AltchaOperation;
};

/**
 * widgetスロットは必ずforwardRef製componentを受ける。本番ビルドはreactを
 * preact/compatへ差し替えており、Preact 10は素の関数componentへの
 * ref-as-propを実装していない。refをpropsへ戻すのはforwardRef/memo/lazyの
 * ときだけで、それ以外ではrefへDOMではなく内部instanceが入る
 * (commit 2257739と同じ事故)。
 */
type AltchaWidgetRenderer = React.ForwardRefExoticComponent<
  AltchaWidgetProps & React.RefAttributes<AltchaWidgetHandle>
>;

interface FormAltchaWidgetProps {
  active?: boolean;
  hideFooter?: boolean;
  operation: AltchaOperation;
  widget?: AltchaWidgetRenderer;
  widgetRef: React.Ref<AltchaWidgetHandle>;
}

const FormAltchaWidget: React.FunctionComponent<FormAltchaWidgetProps> = ({
  active = true,
  hideFooter = false,
  operation,
  widget: Widget = AltchaWidget,
  widgetRef,
}: FormAltchaWidgetProps) => {
  return (
    <Widget
      active={active}
      hideFooter={hideFooter}
      operation={operation}
      ref={widgetRef}
    />
  );
};

type PublicFormAltchaWidgetProps = Omit<FormAltchaWidgetProps, "operation">;

export const ReplyFormAltchaWidget: React.FunctionComponent<
  PublicFormAltchaWidgetProps
> = (props: PublicFormAltchaWidgetProps) => {
  return <FormAltchaWidget {...props} operation="reply" />;
};

export const ThreadFormAltchaWidget: React.FunctionComponent<
  PublicFormAltchaWidgetProps
> = (props: PublicFormAltchaWidgetProps) => {
  return <FormAltchaWidget {...props} operation="thread" />;
};
